export default __webpack_public_path__ + "ee20fad229fddc98de90d8abbdf6b3ac.svg";